import React from "react";
import { CtaButton } from "./CtaButton";
type TransformCtaProps = {
  label: string;
  note?: string;
  tone?: "light" | "dark";
};
export function TransformCta({
  label,
  note = "One-Time Payment of $27 · Instant Download · 7-Day Guarantee",
  tone = "light"
}: TransformCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-316" data-mp="xtogiwqnyuli">
      <CtaButton label={label} data-id="element-317" data-mp="xw17fzeegfap" />
      <p className={`mt-3 text-center text-sm ${tone === "dark" ? "text-white/80" : "text-muted"}`} data-id="element-318" data-mp="a440allwabfx">{note}</p>
    </div>;
}